module.exports = __webpack_public_path__ + "img/index_whole_ban1.e7600404.jpg";